import { Component } from '@angular/core';

@Component({
  selector: 'app-camisas',
  standalone: true,
  imports: [],
  templateUrl: './camisas.component.html',
  styleUrl: './camisas.component.scss'
})
export class CamisasComponent {

}
